<template>
  <div class="panel panel-primary">
    <div class="panel-heading">
      <h3 class="panel-title">Email</h3>
    </div>
    <div class="panel-body">
      <a href="mailto:info@grotec.co.uk">info@grotec.co.uk</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'email-box'
}
</script>